import React from 'react';
import CommonHeader from '../Components/Headers/CommonHeader.jsx';
import ChatBot from '../Components/ChatBot/ChatBot.jsx';

export default function ChatBotPage() {
  return (
    <React.Fragment>
      <CommonHeader />
      <ChatBot />
    </React.Fragment>
  );
}
